import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const SAVE_GOODS_TYPE = "/api/saveGoodsType",//新增或者编辑分类
	GET_GOODS_TYPE_LIST = "/api/getGoodsTypeList",//获取分类列表
	GET_GOODS_TYPE_DETAIL = "/api/getGoodsTypeDetail",//获取分类详情
	DEL_GOODS_TYPE = "/api/deleteGoodsType",//删除商品分类
	SET_GOODS_TYPE_RECOMMENTD = "/api/setGoodsTypeRecommend",//设置商品分类是否为推荐
	SET_GOODS_TYPE_ORDER_NUMBER = "/api/saveGoodsTypeOrderNumber",//设置分类排序
	SAVE_GOODS = "/api/saveGoods",//新增或者编辑商品
	GET_GOODS_DETAIL = "/api/getGoodsDetail",//获取商品详情
	GET_GOODS_LIST = "/api/getGoodsList",//获取商品列表
	DEL_GOODS = "/api/deleteGoods",//删除商品
	SET_GOODS_RECOMMENTD = "/api/setGoodsRecommend",//设置商品是否为推荐
	SET_GOODS_SELL_STATUS = "/api/setGoodsSellStatus",//设置商品上下架
	SET_GOODS_COUNT = "/api/saveGoodsCount",//设置商品库存
	GET_VMALL_CONFIG = "/api/getVmallConfig",//获取微商城配置信息
	SAVE_VMALL_CONFIG = "/api/saveVmallConfig",//保存微商城配置信息
	GET_BANNER_LIST = "/api/getBannerList",//获取轮播列表
	SAVE_BANNER = "/api/saveBanner",//保存轮播数据
	GET_BANNER_INFO = "/api/getBannerInfo",//获取轮播详情
	DEL_BANNER = "/api/deleteBanner",//删除轮播
	GET_ORDER_LIST = "/api/getOrderList",//获取订单列表
	GET_ORDER_DETAIL = "/api/getOrderInfo",//获取订单详情
	GET_ORDER_STATISTICS_INFO = "/api/getOrderStatisticsInfo",//获取订单统计数据
	DELEVER_GOODS = "/api/deleverGoods",//订单发货
	GET_ORDER_STATISTICS_ITEM = "/api/mallOrderStisticItem",//订单统计趋势数据
	VMALL_REFUND = "/api/vmallRefund",//退款
	GET_VMALL_ORDER_COUNT = "/api/getVmallOrderCount",//获取订单页码
	EXPORT_VMALL_ORDER_LIST = "/api/exportVmallOrderList";//导出数据
	
export default {
	getGoodsList: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_GOODS_LIST, params)
			data.list.map((item, index)=> {
				item.recommend = item.recommend ? true:false
			});
			commit('GET_GOODS_LIST', data);
		}catch(e){
			throw e
		}
		
		
		
//		return new Promise((resolve, reject) => {
//			http.get(GET_GOODS_LIST, params)
//				.then((data = {}) => {
//					data.list.forEach(function(item, key) {
//						if (item.recommend) {
//							data.list[key]['recommend'] = true;
//						} else {
//							data.list[key]['recommend'] = false;
//						}
//					});
//					commit('GET_GOODS_LIST', data);
//					resolve();
//				},(err)=>{
//					reject(err.message);
//				})
//		})
	},
	saveGoodsType: ({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.post(SAVE_GOODS_TYPE, params)
	},
	
	getGoodsTypeList: ({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return new Promise((resolve, reject) => {
			http.get(GET_GOODS_TYPE_LIST, params)
				.then((data = {}) => {
					if (params.type == 'page') {
						data.list.forEach(function(item, key) {
							if (item.recommend) {
								data.list[key]['recommend'] = true;
							} else {
								data.list[key]['recommend'] = false;
							}
						});
						
						commit('GET_GOODS_TYPE_LIST', data);
						
						resolve();
						
					} else {
						let newArr = [];
						
						data.list.forEach(function(item, key) {
							newArr.push({value: item.id, text: item.name})					
						})
						
						resolve(newArr);
					}
				},(err)=>{
					reject(err.message)
				})
		})
	},
	
	getGoodsTypeDetail: ({
		commit
	}, params={}) => {
		return http.get(GET_GOODS_TYPE_DETAIL, params)
	},
	
	deleteGoodsType: ({
		commit
	}, params={}) => {
		return http.post(DEL_GOODS_TYPE, params)
	},
	
	setGoodsTypeRecommend: ({
		commit
	}, params={}) => {
		return http.post(SET_GOODS_TYPE_RECOMMENTD, params)
	},
	
	getGoodsDetail: ({
		commit
	}, params={}) => {
		return http.get(GET_GOODS_DETAIL, params)
	},
	
	saveGoods: ({
		commit,
	}, params={}) => {
		return http.post(SAVE_GOODS, params)
	},
	deleteGoods: ({
		commit
	}, params={}) => {
		return http.post(DEL_GOODS, params)
	},
	
	setGoodsRecommend: ({
		commit
	}, params={}) => {
		return http.post(SET_GOODS_RECOMMENTD, params)
	},
	
	getVmallConfig: ({
		commit
	}, params={}) => {
		return http.get(GET_VMALL_CONFIG, params)
	},
	saveVmallConfig: ({
		commit
	}, params={}) => {
		return http.post(SAVE_VMALL_CONFIG, params)
	},
	
	getBannerList: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_BANNER_LIST, params)
			commit('GET_BANNER_LIST', data);
		}catch(e){
			throw e
		}
	},
	
	saveBanner: ({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.post(SAVE_BANNER, params)
	},
	
	getBannerInfo: ({
		commit
	}, params={}) => {
		return http.get(GET_BANNER_INFO, params)
	},
	
	deleteBanner: ({
		commit
	}, params={}) => {
		return http.post(DEL_BANNER, params)
	},
	
	getOrderList: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_ORDER_LIST, params)
			commit('GET_ORDER_LIST', data);
		}catch(e){
			throw e
		}
	},
	
	getOrderInfo: ({
		commit
	}, params={}) => {
		return http.get(GET_ORDER_DETAIL, params)
	},
	
	saveGoodsTypeOrderNumber: ({
		commit
	}, params={}) => {
		return http.post(SET_GOODS_TYPE_ORDER_NUMBER, params)
	},
	
	setGoodsSellStatus: ({
		commit
	}, params={}) => {
		return http.post(SET_GOODS_SELL_STATUS, params)
	},
	
	saveGoodsCount: ({
		commit
	}, params={}) => {
		return http.post(SET_GOODS_COUNT, params)
	},
	
	getOrderStatisticsInfo: async({
		commit
	}, params={}) => {
		try{
			const data = await http.get(GET_ORDER_STATISTICS_INFO, params)
			commit('GET_ORDER_STATISTICS_INFO', data);
		}catch(e){
			throw e
		}
	},
	
	mallOrderStisticItem: ({
		commit
	}, params={}) => {
		return http.get(GET_ORDER_STATISTICS_ITEM, params)
	},
	
	getVmallOrderCount: ({
		commit
	}, params={}) => {
		return http.get(GET_VMALL_ORDER_COUNT, params)
	},
	
	exportVmallOrderList: ({
		commit
	}, params={}) => {
		return http.get(EXPORT_VMALL_ORDER_LIST, params)
	},
	
	deleverGoods: ({
		commit,
		dispatch
	}, params={}) => {
		return http.post(DELEVER_GOODS, params)
	},
	
	vmallRefund: ({
		commit,
		dispatch
	}, params={}) => {
		return http.post(VMALL_REFUND, params)
	},
}


// WEBPACK FOOTER //
// ./src/store/mp/vmall/actions.js